// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__dwo0m","iframeContainer":"styles_iframeContainer__sWaVu"};